import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import "./assets/styles/main.scss";
import { store, persistor } from "./store";
import Routes from "./components/Routes";
import GoogleAnalitics from "./utils/GoogleAnalitics";
import LoginAsBanner from "./components/LoginAsBanner";

const App = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <GoogleAnalitics />
        <Routes />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

ReactDOM.render(<App />, document.getElementById("root"));
